export enum statutForm {
    CREATION = 1,
    EDIT,
    PROPOSE,
}